import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, FormControl, InputLabel, Select, MenuItem, Alert } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';

/**
 * Language Settings component
 * Form for managing language preferences
 *
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data
 * @param {Function} props.handleLanguageChange - Function to handle language changes
 * @returns {JSX.Element} The LanguageSettings component
 */
const LanguageSettings = ({ formData, handleLanguageChange }) => {
  const { t } = useTranslation('user');

  return (
    <Grid
      container
      spacing={3}
    >
      <Grid
        item
        xs={12}
      >
        <Typography
          variant="h6"
          gutterBottom
        >
          {t('forms.languageSettings')}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2 }}
        >
          {t('forms.languageDescription')}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <FormControl
          fullWidth
          variant="outlined"
        >
          <InputLabel id="language-select-label">{t('forms.language')}</InputLabel>
          <Select
            labelId="language-select-label"
            id="language-select"
            name="language"
            value={formData.language}
            onChange={handleLanguageChange}
            startAdornment={<LanguageIcon sx={{ mr: 1 }} />}
            label={t('forms.language')}
          >
            <MenuItem value="en">English</MenuItem>
            <MenuItem value="de">Deutsch</MenuItem>
            <MenuItem value="fr">Français</MenuItem>
            <MenuItem value="it">Italiano</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid
        item
        xs={12}
      >
        <Alert
          severity="info"
          sx={{ mt: 2 }}
        >
          {t('forms.languageChangeInfo')}
        </Alert>
      </Grid>
    </Grid>
  );
};

export default LanguageSettings;
